import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks/hooks';
import { selectSubmitCounter, setSubmitCount } from '../../../redux/slices/submitCounterSlice';

interface IDetailViewPostButtonProps {
  onSave: () => void;
}

const DetailViewSaveButton = ({ onSave }: IDetailViewPostButtonProps) => {
  const [saveClicked, setSaveClicked] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const counter = useAppSelector(selectSubmitCounter);
  const { t } = useTranslation();

  const handleSaveClick = async () => {
    setSaveClicked(true);
    await onSave();
    dispatch(setSubmitCount(counter + 1));
    setSaveClicked(false);
  };
  return (
    <>
        <button type={"submit"} className={"btn btn-light"} onClick={handleSaveClick}>
            {saveClicked ? (
              <>
                <i className="fa-solid fa-spinner fa-spin-pulse me-2"></i> {t("Saving")}
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk me-2"></i>
                {t("Save")}
              </>
            )}
          </button>
    </>
  );
};

export default DetailViewSaveButton;
